import { Text } from '@akin-home/text/native';
import { useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { TextInput } from '../TextInput';
import { TextInputProps } from '../TextInput/TextInput.props';

export const PasswordInput = (props: TextInputProps) => {
  const [hidden, setHidden] = useState(true);

  const toggleHidden = () => setHidden((hidden) => !hidden);

  return (
    <TextInput
      {...props}
      autoCapitalize="none"
      secureTextEntry={hidden}
      right={
        <TouchableOpacity onPress={toggleHidden}>
          <Text variant="caption">{hidden ? 'Show' : 'Hide'}</Text>
        </TouchableOpacity>
      }
    />
  );
};
